export default __webpack_public_path__ + "static/media/Mockup for Contest Prize.4a1d16fb.svg";